import { Typography } from '../../../components/typography/typography';
import { ProductCard } from '../product-card';
import { Location } from '../../../clients/quipli-service/location/location';
import { CustomerProduct } from '../../../clients/customer-api/product/customer-product';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Carousel } from '../../../components/carousel/carousel';
import { Label } from '../../../clients/quipli-service/label/label';
import { Dictionary, keyBy } from 'lodash';
import './related-products.scss';
import { useState, useEffect } from 'react';
import { OrderType } from '../../../clients/quipli-service/order/order';
import {
  RentalProductPrice,
  CalculateSalePriceResult,
  ErrorCalculatePriceResult,
} from '../../../clients/quipli-service/pricing/pricing';
import { useCustomerAPI } from '../../../clients/customer-api/customer-api-client';
import { Configuration } from '../../../clients/quipli-service/configuration/configuration';
import { EcommerceUser } from '../product-details/product-details';

export const RelatedProducts = ({
  relatedProducts,
  location,
  user,
  labels,
  configs,
  tagDiscount,
}: {
  relatedProducts: CustomerProduct[];
  location: Location & { urlAlias: string };
  user: EcommerceUser;
  labels: Dictionary<Label>;
  configs: Dictionary<Configuration>;
  tagDiscount: number;
}) => {
  const [rentalPrices, setRentalPrices] = useState<Map<number, RentalProductPrice[]>>(new Map()),
    [salePrices, setSalePrices] = useState<Dictionary<CalculateSalePriceResult>>({});

  const { listPricesForMultipleProducts, calculatePrices } = useCustomerAPI();
  useEffect(() => {
    const init = async () => {
      const saleItems = relatedProducts.filter((item) => item.allowSale);
      const rentalItems = relatedProducts.filter((item) => item.allowRent);

      const [_rentalPrices, _salePrices] = await Promise.all([
        rentalItems.length
          ? listPricesForMultipleProducts(
              rentalItems.map((p) => p.id),
              location.id,
              OrderType.Rental,
              user.userId,
            )
          : [],
        saleItems.length
          ? calculatePrices(
              saleItems.map((p) => ({
                productId: p.id,
                type: OrderType.Sale,
                locationId: location.id,
                userId: user.userId,
              })),
            )
          : [],
      ]);
      setRentalPrices(_rentalPrices as Map<number, RentalProductPrice[]>);
      setSalePrices(
        keyBy(
          _salePrices.filter((sp) => !(sp as ErrorCalculatePriceResult).error) as CalculateSalePriceResult[],
          'productId',
        ),
      );
    };
    init();
  }, []);

  return relatedProducts.length > 0 ? (
    <div className="related-products-v2">
      <Typography type="display-sm" weight="bold">
        Frequently rented with this item
      </Typography>
      <div className="px-0 block mt-3">
        <Carousel className="">
          {relatedProducts?.map((product) => {
            return (
              <div className="h-full justify-self-center">
                <ProductCard
                  key={product.id}
                  product={product}
                  location={location}
                  isLoggedIn={user.isLoggedIn}
                  labels={labels}
                  configs={configs}
                  rentalPrices={rentalPrices.get(product.id)}
                  salePrice={salePrices[product.id]?.totalPrice}
                  tagDiscount={tagDiscount}
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  ) : (
    <></>
  );
};
